import { TableBody as TBody } from "@mui/material";

import { UnknownFund } from "../types";
import UnknownFundRow from "./UnknownFundRow/UnknownFundRow";

// ----------------------------------------------------------------------

type Props = {
	data: UnknownFund[];
};

export default function TableBody({ data }: Props) {
	return (
		<TBody>
			{data.map((row, index) => (
				<UnknownFundRow {...row} key={index} />
			))}
		</TBody>
	);
}
